/**
 * Formats a date string to a locale-specific string representation.
 * @param dateString - ISO date string or date-compatible string
 * @returns Formatted date string (e.g., "12/25/2023, 3:30:00 PM")
 */
export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleString();
};

/**
 * Formats an optional date string, returning a placeholder for null/undefined or invalid dates.
 * @param dateString - ISO date string, or null/undefined
 * @param placeholder - String to return when date is null, undefined, or invalid (default: "—")
 * @returns Formatted date string or placeholder
 */
export const formatOptionalDate = (
  dateString: string | null | undefined,
  placeholder = "—"
): string => {
  if (dateString == null) return placeholder;
  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return placeholder;
    return date.toLocaleString();
  } catch {
    return placeholder;
  }
};
